module.exports = __webpack_public_path__ + "media/images/chat-loading-d80898de.svg";